var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOfferSetupIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7013 6.29974C14.5181 6.48666 14.4155 6.73798 14.4155 6.99974C14.4155 7.26149 14.5181 7.51281 14.7013 7.69974L16.3013 9.29974C16.4882 9.48296 16.7396 9.58559 17.0013 9.58559C17.2631 9.58559 17.5144 9.48296 17.7013 9.29974L21.4713 5.52974C21.9742 6.64092 22.1264 7.87897 21.9078 9.07888C21.6892 10.2788 21.11 11.3836 20.2476 12.246C19.3852 13.1084 18.2804 13.6876 17.0805 13.9062C15.8806 14.1248 14.6425 13.9726 13.5313 13.4697L6.62132 20.3797C6.2235 20.7776 5.68393 21.0011 5.12132 21.0011C4.55871 21.0011 4.01914 20.7776 3.62132 20.3797C3.2235 19.9819 3 19.4423 3 18.8797C3 18.3171 3.2235 17.7776 3.62132 17.3797L10.5313 10.4697C10.0285 9.35855 9.87624 8.1205 10.0949 6.92059C10.3135 5.72068 10.8926 4.61589 11.755 3.75346C12.6175 2.89102 13.7223 2.3119 14.9222 2.09328C16.1221 1.87465 17.3601 2.0269 18.4713 2.52974L14.7113 6.28974L14.7013 6.29974Z",
    stroke: "#2C3B48",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferSetupIcon);
export default __webpack_public_path__ + "static/media/offerSetupIcon.5af72f8bae430e2da8e094eae069371c.svg";
export { ForwardRef as ReactComponent };